import React, { useState } from "react";
import { Button } from "@amzn/awsui-components-react";
import { downloadFirstPassResults } from "../pdfUtils";
import { downloadFirstPassExcel } from "../excelUtils";
import DownloadFormatModal from "./DownloadFormatModal";

const DownloadResultsButton = ({ data, viewOption }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [showFormatModal, setShowFormatModal] = useState(false);

  const handleDownloadClick = () => {
    if (!data) return;
    setShowFormatModal(true);
  };

  const handleDownloadConfirm = async (format) => {
    setShowFormatModal(false);
    if (!data) return;

    if (format === "excel") {
      await downloadFirstPassExcel(
        data,
        () => setIsDownloading(true),
        () => setIsDownloading(false),
        viewOption
      );
    } else {
      await downloadFirstPassResults(
        data,
        () => setIsDownloading(true),
        () => setIsDownloading(false),
        'rich',
        viewOption
      );
    }
  };

  return (
    <>
      <Button
        iconName="download"
        variant="icon"
        onClick={handleDownloadClick}
        disabled={isDownloading}
        loading={isDownloading}
      />
      <DownloadFormatModal
        visible={showFormatModal}
        onDismiss={() => setShowFormatModal(false)}
        onConfirm={handleDownloadConfirm}
      />
    </>
  );
};

export default DownloadResultsButton;
